<template>
    <AddTimepenalty v-model="refValue"></AddTimepenalty>
</template>
<script setup lang="ts">
import { AddTimepenalty } from '@/components';
import type { TimepenaltyRequest } from '@/objects/generated';
import { ref, watch } from 'vue';

const props = defineProps<{
    value: { wrapper: { request: TimepenaltyRequest } };
}>();

// Create a mutable copy of the data.
let mutableValue: { request: TimepenaltyRequest } = props.value.wrapper;

// Create a ref for the component with the mutable value
const refValue = ref<TimepenaltyRequest>(mutableValue.request);

// Update the mutable value when the ref value changes
// watch(refValue, (value) => (mutableValue.request = value), { deep: true });
watch(
    () => refValue,
    (value) => {
        mutableValue.request = value.value;
    },
    { deep: true },
);
</script>
